import React from 'react'
import {Grid} from '@mui/material'

function Index({data}) {
    return (
        <div>
            <Grid className='wrapper' container>
                    <Grid className='column-1' item lg={3.5} md={3.5} sm={4} xs={12}>
                        <img src={ data.img}alt="" />
                    </Grid>

                    <Grid className='column-2' item lg={8.5} md={8.5} sm={8} xs={12}>
                        <h3 className='name'>{data.name}</h3>
                        <p className='title-comp'>{data.title}</p>
                        <p className='body'>
                            {data.body}
                        </p>
                    </Grid>
                </Grid> 
        </div>
    )
}

export default Index
